<template>
  <AuthLayout title="Login" heading="Sign in to your account">
    <template #link>
      <LinkBase :href="route('register')">register for a new account</LinkBase>
    </template>

    <form class="space-y-6" @submit.prevent="form.post(route('login'))">
      <div>
        <InputGroup
          v-model="form.email"
          type="email"
          label="Email address"
          :error="form.errors.email"
          autocomplete="email"
          required
          autofocus
        />
      </div>

      <div>
        <InputGroup
          v-model="form.password"
          type="password"
          label="Password"
          :error="form.errors.password"
          autocomplete="current-password"
          required
        />
      </div>

      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <CheckboxBase
            v-model="form.remember"
            id="remember-me"
            name="remember-me"
          />

          <LabelBase class="ml-2" for="remember-me" value="Remember me" />
        </div>

        <div class="text-sm">
          <LinkBase :href="route('password.request')"
            >Forgot your password?</LinkBase
          >
        </div>
      </div>

      <ButtonBase
        type="submit"
        class="w-full justify-center"
        :processing="form.processing"
        >Sign In</ButtonBase
      >
    </form>
  </AuthLayout>
</template>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3'

import AuthLayout from '@/Layouts/AuthLayout.vue'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'
import LabelBase from '@/Common/Forms/LabelBase.vue'
import LinkBase from '@/Common/Text/LinkBase.vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import CheckboxBase from '@/Common/Forms/Checkboxes/CheckboxBase.vue'

const form = useForm({
  email: null,
  password: null,
  remember: false,
})
</script>
